import React from 'react';

const GoogleAnalytics = () => {
    return (
        <>
            {/* Google tag (gtag.js) */}
            <script async src="https://www.googletagmanager.com/gtag/js?id=G-NGPN3YWNZJ" ></script >
            <script>
                {` window.dataLayer = window.dataLayer || [];
               function gtag(){dataLayer.push(arguments);}
               gtag('js', new Date());

               gtag('config', 'G-NGPN3YWNZJ');`}
            </script>
        </>
    );
};

export default GoogleAnalytics;
